/* v8 ignore start */
import {LottieAnimatedPropertyModel} from "@/lib/lottie/animatedProperties/lottieAnimatedPropertyModel";
import {LottieKeyFrameModel} from "@/lib/lottie/animatedProperties/lottieKeyframeModel";

export class LottieMultiDimensionalModel extends LottieAnimatedPropertyModel<
  number[],
  LottieMultiDimensionalModel.TJson
> {
  public adjustTimingBy(factor: number): this {
    if (!this.json.a) return this;

    return this.update({k: this.json.k.map((keyframe) => ({...keyframe, t: keyframe.t * factor}))});
  }

  public offsetTimingBy(offset: number): this {
    if (!this.json.a) return this;

    return this.update({k: this.json.k.map((keyframe) => ({...keyframe, t: keyframe.t + offset}))});
  }
}

export namespace LottieMultiDimensionalModel {
  export type TJson = IStaticAnimatedPropertyJson<number[]> | IKeyframeAnimatedPropertyJson;

  interface IBaseJson<T> extends LottieAnimatedPropertyModel.IBaseJson<T> {
    /**
     * Number of components in the value arrays.
     * If present values will be truncated or expanded to match this length when accessed from expressions.
     */
    l?: number;
  }

  interface IStaticAnimatedPropertyJson<T> extends IBaseJson<T> {
    a?: 0;
    k: T;
  }

  interface IKeyframeAnimatedPropertyJson extends IBaseJson<never> {
    a: 1;
    k: LottieKeyFrameModel.IJson[];
  }
}
/* v8 ignore stop */
